import { useEffect } from 'react';

const useIntersectionObserver = ({
  root,
  target,
  onIntersect,
  threshold = 1.0,
  rootMargin = '0px',
  enabled = true,
}) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    // https://gist.githubusercontent.com/arijitMondal/215cc04436856f63a8375161ce5089dc/raw/5362e8a5e725daa0de9a773fa0462e39b3ee9493/polyfill_detection.js

    const observer = new IntersectionObserver(
      entries =>
        entries.forEach(entry => entry.isIntersecting && onIntersect()),
      {
        root: root && root.current,
        rootMargin,
        threshold,
      }
    );

    const el = target && target.current;

    if (!el) {
      return;
    }

    observer.observe(el);

    // eslint-disable-next-line consistent-return -- FIXME
    return () => {
      observer.unobserve(el);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [target.current, enabled]);
};

export default useIntersectionObserver;
